import React from 'react';

import {
  useShowSaleBanner,
  MAY_2025_BANNER_KEY,
  MAY_2025_LAST_CHANCE_BANNER_KEY,
} from '~/src/common/courses';

import { May2025Banner } from './May2025Banner';

export const SaleBanner: React.FC = () => {
  const { isShown, bannerKey } = useShowSaleBanner();
  if (!isShown) {
    return null;
  }

  return (
    <>
      {(bannerKey === MAY_2025_BANNER_KEY || bannerKey === MAY_2025_LAST_CHANCE_BANNER_KEY) && (
        <May2025Banner
          isShown={isShown}
          lastChance={bannerKey === MAY_2025_LAST_CHANCE_BANNER_KEY}
        />
      )}
    </>
  );
};
